"use strict";
// TODO: should we retry the data chunk if a flush fails?
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoggerAggregator = void 0;
const periodicSync_1 = require("./periodicSync");
const SEVERITY_KEY = {
    TRACE: "traces",
    DEBUG: "debugs",
    INFO: "infos",
    WARN: "warns",
    ERROR: "errors",
    FATAL: "fatals",
};
class LoggerAggregator extends periodicSync_1.PeriodicSync {
    constructor(client, maxLoggers, syncInterval) {
        super(client, "LoggerAggregator", syncInterval !== null && syncInterval !== void 0 ? syncInterval : 30000);
        this.maxLoggers = maxLoggers;
    }
    record(logger, level) {
        if (this.data.size >= this.maxLoggers)
            return;
        // create counter entry if it doesn't exist
        if (!this.data.has(logger)) {
            this.data.set(logger, {
                loggerName: logger,
                traces: 0,
                debugs: 0,
                infos: 0,
                warns: 0,
                errors: 0,
                fatals: 0,
            });
        }
        // increment count
        const counter = this.data.get(logger);
        if (counter) {
            const severityKey = SEVERITY_KEY[level];
            counter[severityKey] += 1;
        }
    }
    flush(toShip, startAtWas) {
        var _a;
        const loggers = {
            startAt: startAtWas.getTime(),
            endAt: new Date().getTime(),
            loggers: Array.from(toShip.values()),
        };
        (_a = this.client.telemetryUploader) === null || _a === void 0 ? void 0 : _a.post(this.events(loggers));
    }
    events(loggers) {
        const event = { loggers };
        return {
            instanceHash: this.client.instanceHash,
            events: [event],
        };
    }
}
exports.LoggerAggregator = LoggerAggregator;
